import React, { useState } from "react";

import { IconButton, Button } from '@mui/material';

import RefreshIcon from "@mui/icons-material/Refresh"

import useMediaQuery from '@mui/material/useMediaQuery';

import './styles.css'

export default function ResponsiveButton({ className, onClickFn, id, variant, title, setIcon, selected, disabled=false, refreshable=false }) {

    const [hover, setHover] = useState(false)
    
    const isSmallScreen = useMediaQuery('(max-width: 60rem)');

    return (
        <>
            {isSmallScreen ? (
                <IconButton
                    className={`${className} btnStart ${! selected ? 'btnInactive' : ''}`}
                    onClick={onClickFn}
                    id={id}
                    key={id}
                    size="small"
                    variant={variant}
                >
                    {setIcon}
                </IconButton>
            ) : (
                <Button className={`${className} btnStart ${! selected ? 'btnInactive' : ''}`}
                    onClick={onClickFn}
                    id={id}
                    key={id}
                    variant={variant}
                    endIcon={(refreshable && selected && hover) ? (<RefreshIcon/>) : setIcon}
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    disabled={disabled}
                >
                    {(refreshable && selected && hover) ? "Atualizar" : title}
                </Button>
            )}
        </>
    )
}
